/** Pick one image from the library and return a downscaled JPEG data-URI (base64) for
 *  the plan-first vision call — or null if cancelled/unavailable. The server downscales
 *  further (max_image_resolution), so quality 0.6 just keeps the upload small. */
export async function pickVibeImage(): Promise<string | null> {
  try {
    const ImagePicker = await import('expo-image-picker');
    // launchImageLibraryAsync uses the out-of-process PHPicker on iOS — no permission gate.
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ['images'],
      quality: 0.6,
      base64: true,
    });
    const asset = !result.canceled ? result.assets?.[0] : undefined;
    if (!asset?.base64) return null;
    return `data:${asset.mimeType ?? 'image/jpeg'};base64,${asset.base64}`;
  } catch {
    return null;
  }
}
